import React from 'react';
import PropTypes from 'prop-types';
import styles from './Close.css';
import { IconShapeCrossCircle } from '@xingternal/malt-icon';
import classnames from 'classnames';
import testable from '@xingternal/malt-util/testable';
import { QA_MALT } from '@xingternal/malt-constants';

const TestableButton = testable(QA_MALT, 'button');

const Close = ({ onClick, className, handlers, testId }) => (
  <TestableButton
    onClick={onClick}
    {...handlers}
    className={classnames(className, styles.close)}
    testId={testId}
  >
    <IconShapeCrossCircle className={styles.closeIcon} />
  </TestableButton>
);

Close.propTypes = {
  /** custom classNames applied to the button */
  className: PropTypes.string,
  /** callback that handles click events on the button */
  onClick: PropTypes.func.isRequired,
  /**
   * additional handlers that are applied to the button
   *
   * ```jsx
   * <Close handlers={{ hover: myHoverHandler }} />
   * ```
   */
  handlers: PropTypes.object,
  /** define a testid for the button */
  testId: PropTypes.string,
};

Close.displayName = 'Close';

export default Close;
